import store from '@/store'

export default {
  namespaced: true,
  actions: {
    Grade(): Promise<any> {
      return Promise.all([
        store.dispatch('mall/fetchMalls', {}, { root: true })
      ])
    },
    Group(): Promise<any> {
      return Promise.all([
        store.dispatch('mall/fetchMalls', {}, { root: true })
      ])
    },
    Freeze(): Promise<any> {
      return Promise.all([
        store.dispatch('mall/fetchMalls', {}, { root: true })
      ])
    },
    Expel(): Promise<any> {
      return Promise.all([
        store.dispatch('mall/fetchMalls', {}, { root: true })
      ])
    }
  }
}